var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead,"list-view":"lgAndUp"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }